import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import CityPage from './pages/CityPage'
import GlobalHubPage from './pages/GlobalHubPage'
import SegmentPage from './pages/SegmentPage'
import AffiliateRedirect from './pages/AffiliateRedirect'
import { LocaleProvider, useLocale } from './contexts/LocaleContext'
import { getGlobalHubSlug } from './utils/getSlugs'
import { AFFILIATE } from './config/affiliate'
import StickyButton from './components/StickyButton'
import Popup from './components/Popup'
import './App.css'

function AppRoutes() {
  const { translations } = useLocale()
  const globalHubSlug = getGlobalHubSlug(translations)
  
  // Get all page slugs for routing (including all internal pages)
  const allPageSlugs = translations?.pages?.slugs || {}
  const allInternalPageKeys = [
    'rankings', 'free', 'safety', 'discreet', 'speed', 
    'comparisons', 'beginner', 'telegram', 'discord', 
    'socialMedia', 'onlyfans', 'pornTube', 'edgy'
  ]
  
  // Get all slugs that should have routes
  const allPageRoutes = allInternalPageKeys
    .map(key => ({
      key,
      slug: allPageSlugs[key]
    }))
    .filter(page => page.slug) // Only include pages that have slugs

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path={`/${AFFILIATE}`} element={<AffiliateRedirect />} />
      <Route path={`/${globalHubSlug}`} element={<GlobalHubPage />} />
      {/* Route for all segment/internal pages */}
      {allPageRoutes.map((page) => (
        <Route key={page.key} path={`/${page.slug}`} element={<SegmentPage />} />
      ))}
      <Route path="/:citySlug" element={<CityPage />} />
    </Routes>
  )
}

function App() {
  return (
    <LocaleProvider>
      <Router>
        <AppRoutes />
        <StickyButton />
        <Popup />
      </Router>
    </LocaleProvider>
  )
}

// Debug: Add function to clear popup sessionStorage (for testing)
if (typeof window !== 'undefined') {
  window.clearPopupSession = () => {
    sessionStorage.removeItem('transdates-popup-shown')
    console.log('Popup session cleared - refresh page to see popup')
  }
}

export default App
